import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-316bc993"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-icons2 FilterIcon" }, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Title" }, " Discipline ", -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "Badge"
}
const _hoisted_4 = { class: "RefineContentOptionsList" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-arrow-left" }, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All disciplines", -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["data-filter"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "DisciplineName" }
const _hoisted_11 = {
  key: 1,
  class: "Facet"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["DisciplineFilterWrapper", {'is-collapsed': _ctx.collapsed}])
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _hoisted_1,
      _hoisted_2,
      (_ctx.filterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", {
        class: _normalizeClass({'Hidden': !_ctx.isDisciplineSelected})
      }, [
        _createElementVNode("button", {
          class: "ShowMainDisciplines",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeSelection()))
        }, _hoisted_7)
      ], 2 /* CLASS */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disciplineFilterOptions, (discipline, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (_ctx.showDiscipline(discipline.optionValue, discipline.parentIdentity))
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                "data-filter": _ctx.key,
                class: _normalizeClass(["Discipline", {'is-active': discipline.optionValue === _ctx.selectedDiscipline,
						'Discipline': discipline.parentIdentity === undefined,
						'SubDiscipline': discipline.parentIdentity !== undefined}])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({'is-active': discipline.optionValue === _ctx.selectedDiscipline,
							'MainDiscipline': discipline.parentIdentity === undefined,
							'SubDiscipline': discipline.parentIdentity !== undefined}),
                  onClick: ($event: any) => (_ctx.selectOption(discipline))
                }, [
                  (discipline.parentIdentity === undefined)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(["DisciplineIcon", _ctx.getIconOf(discipline)])
                      }, null, 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(discipline.optionName), 1 /* TEXT */),
                  (_ctx.displayFacets)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.facet(discipline.optionValue)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 10 /* CLASS, PROPS */, _hoisted_9)
              ], 10 /* CLASS, PROPS */, _hoisted_8))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 2 /* CLASS */))
}